export const phoneTypes = ['Mobile', 'Home', 'Business'];
